<template>
    <div class="ex-page">
        <div class="mob_nav">
            <MobNav />
        </div>

        <!-- ===== 身份条 ===== -->
        <div class="ex-idbar">
            <div class="ex-cover">
                <div class="ex-play"></div>
            </div>
            <div class="ex-idmain">
                <div class="ex-name">{{ lessonTitle }}</div>
                <div class="ex-chips">
                    <span class="ex-chip" v-if="lesson.teacherName">教学老师 · {{ lesson.teacherName }}</span>
                    <span class="ex-chip" v-if="lesson.className">班级 · {{ lesson.className }}</span>
                    <span class="ex-chip" v-if="lesson.courseName">课程 · {{ lesson.courseName }}</span>
                    <span class="ex-chip tmpl" v-if="lesson.templateName">模板 · {{ lesson.templateName }}</span>
                    <span class="ex-chip" v-if="!hasLessonInfo">请从「在线资源」选择要评的课程</span>
                </div>
            </div>
            <div class="ex-kpis">
                <div class="ex-kpi" style="--c:#4fc3ff">
                    <div class="num">{{ rules.length }}</div>
                    <div class="lbl">评课维度</div>
                </div>
                <div class="ex-kpi" style="--c:#35e0b0">
                    <div class="num">{{ scoredCount }}<small>/{{ totalCount }}</small></div>
                    <div class="lbl">已评指标</div>
                </div>
                <div class="ex-kpi" style="--c:#ffd24a">
                    <div class="num">{{ totalScore }}</div>
                    <div class="lbl">当前总分</div>
                </div>
            </div>
        </div>

        <!-- ===== 主体 ===== -->
        <div class="ex-body">
            <!-- 左：视频 + 过程记录 -->
            <div class="ex-left">
                <div class="ex-card ex-video-card">
                    <div class="ex-sectitle">
                        课堂视频
                        <span class="ex-actions" v-if="!video.url">
                            <label for="file-upload-center" class="ex-link">本地上传</label>
                            <span class="ex-line">|</span>
                            <span class="ex-link" @click="isSearch = true">在线资源</span>
                        </span>
                    </div>
                    <div class="ex-video-wrap">
                        <div v-if="!video.url" class="ex-video-empty">
                            <i class="el-icon-upload2 ex-vup"></i>
                            <div class="t1">将视频拖拽到此处，或点击下方按钮上传</div>
                            <div class="t2">支持不超过 10G 的视频文件，MP4、AVI、MOV 等格式</div>
                            <label for="file-upload-center" class="ex-btn">点击上传</label>
                            <input @change="uploadChange" id="file-upload-center" type="file"
                                style="display: none;cursor: pointer;" />
                        </div>
                        <template v-else>
                            <AliPlayerVOD ref="alipayvodEl" v-if="!video.live" :url="video.url"></AliPlayerVOD>
                            <AliPlayer v-else :url="video.url" />
                        </template>
                    </div>
                </div>

                <div class="ex-card ex-record-card">
                    <div class="ex-sectitle">
                        过程记录
                        <span class="more">{{ form.logs.length }} 条</span>
                        <span class="ex-btn sm" @click="handleHistory">新建记录</span>
                    </div>
                    <div class="ex-logs">
                        <div class="ex-log" v-for="item, index in form.logs" :key="index">
                            <div class="ex-log-head">
                                <span class="ex-time">{{ timeText(item.position) }}</span>
                                <span class="ex-del" @click="handleClear(index)">移除</span>
                            </div>
                            <el-input type="text" placeholder="说点什么" v-model="item.content"></el-input>
                        </div>
                        <div class="ex-blank" v-if="!form.logs.length">
                            暂无记录 —— 点击「新建记录」，会在视频当前播放时间点插入一条
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右：评课维度 -->
            <div class="ex-right">
                <div class="ex-card ex-eval-card">
                    <div class="ex-sectitle">
                        评课维度
                        <span class="more">{{ scoredCount }} / {{ totalCount }} 项已评</span>
                    </div>
                    <div class="ex-progress" v-if="totalCount">
                        <i :style="{ width: percent + '%' }"></i>
                    </div>
                    <div class="ex-rules">
                        <Group v-for="item, index in rules" :key="index" :name="item.name" :list="item.children"
                            :open="true" :score="item.score" :color="palette[index % palette.length]"
                            @changeRule="(val) => changeRule(val, item, index)" />
                        <div class="ex-blank" v-if="!rules.length">请选择要评课的课程</div>
                        <div style="height: 10px;"></div>
                    </div>
                    <div class="ex-submit-bar">
                        <button class="ex-submit" @click="handleNav('save')">提交评课</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- mobile -->
        <div class="mobile_submit d-flex items-center">
            <div class="flex-1 d-flex a-center j-center">
                <button class="ex-submit ghost" @click="handleNav('clear')">清除当前课程</button>
            </div>
            <div class="flex-1 d-flex a-center j-center">
                <button class="ex-submit" @click="handleNav('save')">保存评课信息</button>
            </div>
        </div>

        <!-- 选择课程 -->
        <el-dialog title="选择课程" :visible.sync="isSearch" :modal="true" class="ex-dialog">
            <div class="ex-search d-flex a-center">
                <div style="width:200px;margin-right:10px;">
                    <el-input type="text" v-model="query.keyword" placeholder="评课标题" clearable></el-input>
                </div>
                <button class="ex-btn" @click="lesson_lists">查询</button>
            </div>

            <el-table :data="tableData" class="ex-table">
                <el-table-column prop="title" label="评课标题" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subjectName" label="学科" align="center"></el-table-column>
                <el-table-column prop="className" label="班级" align="center"></el-table-column>
                <el-table-column prop="courseName" label="课程名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="评课类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.reviewType == 1">AI评价</span>
                        <span v-else-if="scope.row.reviewType == 2">专家评</span>
                        <span v-else-if="scope.row.reviewType == 3">人机协同</span>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评课方式" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">视频</span>
                        <span v-else-if="scope.row.type == 2">直播</span>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="teacherName" label="教学老师" align="center"></el-table-column>
                <el-table-column prop="templateName" label="评课模板" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="操作" align="center" width="90">
                    <template slot-scope="scope">
                        <button class="ex-btn sm" @click="handleUseLesson(scope.row)">使用</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="ex-pager">
                <el-pagination background layout="total, prev, pager, next, sizes" :total="total"
                    :page-sizes="pageSizes" :page-size="query.size" @size-change="onSize" @current-change="onCurrPage"
                    @prev-click="onCurrPage" @next-click="onCurrPage">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Group from './comp/group.vue'
import { computeScore } from '@/global/utils'
import { lesson_submit, template, get, lists, lesson_video, reviewRecord } from '@/request/api/lession.js'
import MobNav from '@/components/MobileMenu.vue'
import AliPlayer from './comp/AliPlayer.vue'
import AliPlayerVOD from './comp/AliplayerVOD.vue'
import moment from 'moment'
export default {
    components: {
        Group,
        MobNav,
        AliPlayerVOD,
        AliPlayer
    },
    data() {
        return {
            template_id: '',
            rules: [],//评课组
            teacher_id: '',
            lesson: {},//当前课程信息（身份条）
            palette: ['#4fc3ff', '#35e0b0', '#ffd24a', '#a78bfa', '#ff8f7c', '#7ad1ff'],
            form: {
                lessonId: '',
                logs: [],
                rules: [],
                expertRules: [],
            },
            query: { keyword: '', page: 1, size: 10 },
            pageSizes: [10, 30, 50, 100],
            total: 0,
            tableData: [],
            video: {
                live: false,
                url: null,
                start_time: null,
                end_time: null
            },
            complexRules: [],
            expertRules: [],
            isSearch: false,// search status
            templateLevel: 2,
        }
    },
    computed: {
        lessonTitle() {
            return this.lesson.title || (this.form.lessonId ? '课程评课' : '专家评课')
        },
        hasLessonInfo() {
            return !!(this.lesson.title || this.lesson.teacherName || this.lesson.subjectName
                || this.lesson.className || this.lesson.courseName || this.lesson.templateName)
        },
        // 已评 / 总指标项
        scoredCount() {
            let n = 0
            this.rules.forEach(g => {
                (g.children || []).forEach(c => { if (c.score || c.max) n++ })
            })
            return n
        },
        totalCount() {
            let n = 0
            this.rules.forEach(g => { n += (g.children || []).length })
            return n
        },
        percent() {
            if (!this.totalCount) return 0
            return Math.round(this.scoredCount / this.totalCount * 100)
        },
        totalScore() {
            let n = 0
            this.rules.forEach(g => { n += (g.score || 0) })
            return +n.toFixed(2)
        }
    },
    created() {
        this.template_id = this.$route.query.template_id || ''
        this.form.lessonId = this.$route.query.lesson_id || ''
        this.teacher_id = this.$route.query.teacher_id || ''
        this.init()

    },
    watch: {
        "$route": function (val) {
            this.template_id = val.query.template_id || ''
            this.form.lessonId = val.query.lesson_id || ''
            this.teacher_id = val.query.teacher_id || ''
            this.video.url = null
            this.lesson = {}
            this.init()
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.lesson_lists()
            if (!this.form.lessonId) return;
            template(this.form.lessonId).then(res => {
                this.templateLevel = res.data.level;
                if (res.data.level === 2 || res.data.level === 5) {
                    res.data.rules && res.data.rules.forEach(item => {
                        item.children && item.children.forEach(itx => {
                            itx['max'] = 0
                        })
                        // score 必须在初始化时声明为响应式，否则总分组件/汇总无法联动
                        this.$set(item, 'score', item.score || 0)
                    })
                    this.rules = res.data.rules
                } else {
                    // 处理三级结构，提取所有二级结构
                    this.rules = [];
                    res.data.rules && res.data.rules.forEach(topLevel => {
                        if (topLevel.children && topLevel.children.length > 0) {
                            topLevel.children.forEach(secondLevel => {
                                // 为每个二级结构的子项初始化 max 为 0
                                if (secondLevel.children && secondLevel.children.length > 0) {
                                    secondLevel['parentId'] = topLevel.id;
                                    secondLevel.children.forEach(thirdLevel => {
                                        thirdLevel['max'] = 0;
                                    });
                                }
                                // score 必须在初始化时声明为响应式，否则总分组件/汇总无法联动
                                this.$set(secondLevel, 'score', secondLevel.score || 0);
                                // 将二级结构添加到 rules 数组中
                                this.rules.push(secondLevel);
                            });
                        }
                    });
                }
            })

            //获取视频地址
            this.getLesson()
            this.getReviewRecord()
        },

        // 秒 -> 时:分:秒
        timeText(position) {
            let p = Number(position) || 0
            let h = Math.floor(p / 3600)
            let m = Math.floor((p % 3600) / 60)
            let s = p % 60
            let mm = m < 10 ? '0' + m : m
            let ss = s < 10 ? '0' + s : s
            return h > 0 ? (h + ':' + mm + ':' + ss) : (mm + ':' + ss)
        },

        //获取自己的打分
        async getReviewRecord() {
            let { rules, logs } = await reviewRecord(this.form.lessonId)
            this.form.logs = logs
            this.form.rules = rules
            this.complexRules = rules
            this.expertRules = rules
            this.setRules()
        },

        //课程详情 
        getLesson() {
            get(this.form.lessonId).then(res => {
                this.lesson = res.data || {}
                this.video.start_time = res.data.liveStartTime
                this.video.end_time = res.data.liveEndTime
                this.getCloudVideo()
            })
        },

        getCloudVideo() {
            lesson_video(this.form.lessonId).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' })
                if (res.data.videoUrl) {
                    this.video.live = false
                    this.video.url = res.data.videoUrl
                } else {
                    this.video.live = true
                    this.video.url = res.data.liveUrl
                }
            })
        },


        lesson_lists() {
            lists(this.query).then(res => {
                this.tableData = res.data.list
                this.total = res.data.total
            })
        },

        uploadChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.video.url = URL.createObjectURL(file);
                this.video.live = false;
            }
        },
        handleHistory() {
            let time = 0
            try {
                if (!this.video.live) {
                    time = Math.floor(this.$refs.alipayvodEl.getCurrentTime())
                } else {
                    //直播
                    var startDate = moment(this.video.start_time)
                    var start_time = startDate.valueOf()
                    var current_time = Date.now()
                    time = Math.floor((current_time - start_time) / 1000)
                }
            } catch (e) {
                // 播放器尚未就绪（如本地环境无 STS 凭证），记录从 00:00 开始
                time = 0
            }
            let obj = {
                content: '',
                lessonId: this.form.lessonId,
                position: time
            }
            this.form.logs.push(obj)
        },

        //赋值评课维度
        setRules() {
            if (!this.expertRules) return;
            this.rules.forEach(obj => {
                let item = this.expertRules.find(item => item.id == obj.id)
                if (item) {
                    obj.score = item.score
                    obj.children.forEach(el => {
                        //指标项
                        let itx_data = item.children.find(elx => elx.id == el.id)
                        if (itx_data) {
                            Object.keys(el).forEach(key => {
                                el[key] = itx_data[key]
                            })
                        }
                    })
                }
            })
        },

        //清空评课维度
        clearRules() {
            this.rules.forEach(obj => {
                obj.score = null
                obj.children.forEach(el => {
                    el.score = null
                    el.max = 0
                })
            })
        },

        changeRule(val, objects, index) {
            // 使用childIndex来定位指标项，而不是依赖id
            let childIndex = val.childIndex;
            let item = this.rules[index].children[childIndex];

            // 计算实际分数：maxScore对应5个星星，根据选择的星星数计算得分
            let score = computeScore(item.maxScore, val.val);

            // 更新指标项的星星数和分数
            item.max = val.val;
            item.score = score;

            // 重新计算该组的总分
            var arr = 0;
            this.rules[index].children.forEach(child => {
                arr += child.score || 0;
            });
            this.rules[index].score = arr.toFixed(2) * 1;

        },

        req_save() {
            var _this = this

            var rulesForm = [];
            if (this.templateLevel === 2 || this.templateLevel === 5) {
                //如果是二级评课模版（含二级指标模版(新) level=5）
                this.rules.forEach(first => {
                    first.children.forEach(second => {
                        rulesForm.push({ groupId: first.id, itemId: second.id, score: second.score });
                    });
                });
            } else {
                //如果是三级评课模版
                this.rules.forEach(second => {
                    second.children.forEach(third => {
                        rulesForm.push({ groupId: second.parentId, itemId: second.id, thirdId: third.id, score: third.score || 0 });
                    });
                });
            }
            this.form.expertRules = rulesForm;

            console.log('提交参数：', JSON.stringify(this.form));
            lesson_submit(this.form).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                if (!res.msg) {
                    this.$notify({ title: '成功', message: "SUCCESS", type: 'success' });
                    _this.$router.go(-1)
                    return
                }
                if (res.msg) return this.$alert(res.msg, '提示', {
                    confirmButtonText: '我已知晓', callback: action => {
                        _this.$router.go(-1)
                    }
                });

            })
        },
        //删除记录
        handleClear(index) {
            this.form.logs.splice(index, 1)
        },

        //清除本地记录
        clearAll() {
            this.form.logs = []
            this.clearRules()
        },
        handleNav(status) {
            switch (status) {
                case "clear":
                    //window.location.reload()
                    this.clearAll()
                    break;
                case "save":
                    if (!this.form.lessonId || !this.video.url) return this.$notify({ title: '成功', message: "SUCCESS", type: 'success' });
                    this.$confirm('是否确定保存？').then(res => {
                        this.req_save()
                    })
                    break;
                default:
                    break;


            }
        },
        handleUseLesson(data) {
            let obj = { template_id: data.templateId, lesson_id: data.id, teacher_id: data.teacherId }
            this.$router.push({ name: 'screen_lesson', query: obj })
            this.isSearch = false
        },

        //每页条数
        onSize(val) {
            this.query.size = val
            this.init()
        },
        onCurrPage(val) {
            this.query.page = val
            this.init()
        }

    }
}
</script>
<style scoped lang="less">
/* ===== 大屏风格 token（与课程画像/教师画像一致）===== */
@c-blue: #4fc3ff;
@c-green: #35e0b0;
@c-gold: #ffd24a;
@c-text: #cfe6ff;
@c-sub: #7ea6d9;
@c-dim: #5f8fd0;
@card-bg: linear-gradient(180deg, rgba(13, 40, 95, .35), rgba(5, 18, 45, .55));
@card-border: 1px solid rgba(63, 156, 255, .28);

.ex-page {
    height: 100%;
    box-sizing: border-box;
    padding: 8px 4px 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: @c-text;
    font-size: 13px;
    min-height: 0;
}

/* ===== 身份条 ===== */
.ex-idbar {
    flex: none;
    display: flex;
    align-items: center;
    gap: 18px;
    background: linear-gradient(180deg, rgba(16, 55, 130, .4), rgba(6, 20, 50, .55));
    border: 1px solid rgba(63, 156, 255, .3);
    border-radius: 10px;
    padding: 12px 18px;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        left: -60px;
        top: -80px;
        width: 260px;
        height: 260px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(42, 125, 232, .28), transparent 68%);
    }
}

.ex-cover {
    flex: none;
    width: 92px;
    height: 60px;
    border-radius: 8px;
    position: relative;
    z-index: 2;
    background: linear-gradient(150deg, rgba(42, 125, 232, .55), rgba(8, 26, 64, .9));
    border: 1px solid rgba(79, 195, 255, .55);
    box-shadow: 0 0 18px rgba(42, 125, 232, .45);
    display: flex;
    align-items: center;
    justify-content: center;
}

.ex-play {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid rgba(79, 195, 255, .8);
    background: rgba(6, 22, 54, .6);
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid #6fc4ff;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        margin-left: 3px;
    }
}

.ex-idmain {
    flex: 1;
    min-width: 0;
    position: relative;
    z-index: 2;
}

.ex-name {
    font-size: 20px;
    font-weight: 500;
    color: #eaf6ff;
    letter-spacing: 1px;
    text-shadow: 0 0 16px rgba(64, 156, 255, .6);
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ex-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.ex-chip {
    font-size: 12px;
    padding: 3px 12px;
    border-radius: 20px;
    border: 1px solid rgba(63, 156, 255, .4);
    background: rgba(27, 98, 224, .16);
    color: #9ec7ff;

    &.tmpl {
        color: #a78bfa;
        border-color: rgba(167, 139, 250, .45);
        background: rgba(167, 139, 250, .12);
    }
}

/* 身份条右侧小指标 */
.ex-kpis {
    flex: none;
    display: flex;
    gap: 10px;
    position: relative;
    z-index: 2;
}

.ex-kpi {
    min-width: 84px;
    padding: 8px 14px 7px;
    border-radius: 8px;
    text-align: center;
    background: linear-gradient(180deg, rgba(16, 55, 130, .35), rgba(8, 25, 60, .4));
    border: 1px solid rgba(79, 195, 255, .25);
    position: relative;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background: var(--c);
        box-shadow: 0 0 10px var(--c);
    }

    .num {
        font-size: 22px;
        font-weight: 500;
        line-height: 1.1;
        font-family: "DIN Alternate", "Segoe UI", Consolas, sans-serif;
        background: linear-gradient(180deg, #ffffff, var(--c));
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;

        small {
            font-size: 12px;
            margin-left: 1px;
        }
    }

    .lbl {
        font-size: 11px;
        color: @c-sub;
        margin-top: 2px;
    }
}

/* ===== 主体 ===== */
.ex-body {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 58fr 42fr;
    gap: 12px;
}

.ex-left,
.ex-right {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    gap: 12px;
}

/* ===== 卡片 ===== */
.ex-card {
    background: @card-bg;
    border: @card-border;
    border-radius: 8px;
    padding: 12px 14px;
    box-shadow: inset 0 0 24px rgba(20, 70, 170, .15);
    min-height: 0;
}

.ex-video-card {
    flex: 1.4;
    display: flex;
    flex-direction: column;
}

.ex-record-card {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.ex-eval-card {
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* 段标题：菱形 + 渐变下划线 */
.ex-sectitle {
    flex: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #dceeff;
    letter-spacing: 1px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid transparent;
    border-image: linear-gradient(90deg, rgba(63, 156, 255, .8), transparent) 1;

    &::before {
        content: "";
        width: 8px;
        height: 8px;
        background: @c-blue;
        transform: rotate(45deg);
        box-shadow: 0 0 8px @c-blue;
    }

    .more {
        margin-left: auto;
        font-size: 12px;
        color: @c-dim;
        font-weight: 400;
        white-space: nowrap;
    }

    .ex-actions {
        margin-left: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .ex-line {
        color: rgba(126, 166, 217, .5);
    }
}

.ex-link {
    color: @c-blue;
    cursor: pointer;

    &:hover {
        color: #8fd6ff;
    }
}

/* ===== 视频 ===== */
.ex-video-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    /deep/ #J_prismPlayer,
    /deep/ .prism-player,
    /deep/ video {
        width: 100% !important;
        height: 100% !important;
    }
}

.ex-video-empty {
    width: 100%;
    height: 100%;
    min-height: 200px;
    border-radius: 6px;
    border: 1px dashed rgba(79, 195, 255, .35);
    background: linear-gradient(150deg, rgba(20, 60, 120, .28), rgba(4, 14, 36, .5));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .t1 {
        font-size: 14px;
        color: @c-blue;
    }

    .t2 {
        font-size: 12px;
        color: @c-sub;
    }
}

/* 上传图标 */
.ex-vup {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 1px solid rgba(79, 195, 255, .5);
    background: radial-gradient(circle, rgba(42, 125, 232, .3), rgba(6, 22, 54, .6));
    box-shadow: 0 0 18px rgba(42, 125, 232, .35);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #6fc4ff;
    text-shadow: 0 0 10px rgba(111, 196, 255, .8);
}

/* ===== 按钮 ===== */
.ex-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    height: 30px;
    font-size: 12px;
    border-radius: 6px;
    cursor: pointer;
    color: #eaf6ff;
    border: 1px solid rgba(79, 195, 255, .45);
    background: linear-gradient(180deg, rgba(42, 125, 232, .45), rgba(16, 60, 140, .5));
    box-shadow: 0 0 12px rgba(42, 125, 232, .25);
    transition: all .2s ease;
    white-space: nowrap;

    &:hover {
        border-color: rgba(111, 196, 255, .85);
        box-shadow: 0 0 16px rgba(79, 195, 255, .45);
    }

    &.sm {
        height: 24px;
        padding: 0 12px;
        font-size: 12px;
    }
}

.ex-submit {
    width: 100%;
    height: 38px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    letter-spacing: 2px;
    color: #06203f;
    font-weight: 600;
    border: 1px solid rgba(140, 220, 255, .7);
    background: linear-gradient(180deg, #9fe0ff, #4fc3ff 55%, #2b8fe0);
    box-shadow: 0 0 18px rgba(79, 195, 255, .45);
    transition: all .2s ease;

    &:hover {
        box-shadow: 0 0 26px rgba(79, 195, 255, .75);
        transform: translateY(-1px);
    }

    &.ghost {
        color: @c-blue;
        font-weight: 400;
        background: rgba(27, 98, 224, .16);
        border-color: rgba(79, 195, 255, .45);
        box-shadow: none;
    }
}

.ex-submit-bar {
    flex: none;
    padding-top: 10px;
}

/* ===== 进度条 ===== */
.ex-progress {
    flex: none;
    height: 4px;
    border-radius: 2px;
    background: rgba(79, 195, 255, .15);
    margin-bottom: 10px;
    overflow: hidden;

    i {
        display: block;
        height: 100%;
        border-radius: 2px;
        background: linear-gradient(90deg, #4fc3ff, #35e0b0);
        box-shadow: 0 0 10px rgba(79, 195, 255, .6);
        transition: width .3s ease;
    }
}

/* ===== 过程记录 ===== */
.ex-logs {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 4px;
}

.ex-log {
    margin-bottom: 8px;
    padding: 8px 10px;
    border-radius: 6px;
    background: rgba(16, 45, 100, .3);
    border: 1px solid rgba(63, 156, 255, .18);
}

.ex-log-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}

.ex-time {
    font-size: 12px;
    color: @c-blue;
    font-family: "DIN Alternate", Consolas, sans-serif;
    padding: 1px 8px;
    border-radius: 10px;
    background: rgba(27, 98, 224, .22);
    border: 1px solid rgba(79, 195, 255, .3);
}

.ex-del {
    font-size: 12px;
    color: #ff8f7c;
    cursor: pointer;

    &:hover {
        color: #ffb3a3;
    }
}

.ex-blank {
    font-size: 12px;
    color: @c-dim;
    text-align: center;
    padding: 16px 6px;
    line-height: 1.7;
}

/* ===== 评课维度滚动区 ===== */
.ex-rules {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 4px;
}

/* ===== 滚动条 ===== */
/deep/ ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

/deep/ ::-webkit-scrollbar-thumb {
    background: rgba(79, 195, 255, .3);
    border-radius: 3px;
}

/deep/ ::-webkit-scrollbar-track {
    background: transparent;
}

/* ===== 输入框深色化 ===== */
/deep/ .el-input__inner {
    background-color: transparent !important;
    color: #eaf6ff !important;
    border: 1px solid rgba(91, 189, 255, .45) !important;
    background-image: none !important;
    box-shadow: none !important;
    height: 32px;
    line-height: 32px;
}

/deep/ .el-input__inner::placeholder {
    color: rgba(126, 166, 217, .75);
}

/deep/ .el-input__inner:focus {
    border-color: rgba(79, 195, 255, .9) !important;
}

/* ===== 弹窗 ===== */
.ex-search {
    margin-bottom: 16px;
}

.ex-pager {
    margin-top: 16px;
    text-align: center;
}

/deep/ .el-dialog {
    background: linear-gradient(180deg, rgba(9, 30, 68, .98), rgba(4, 14, 36, .99)) !important;
    border: 1px solid rgba(63, 156, 255, .35);
    border-radius: 10px;

    .el-dialog__title {
        color: #eaf6ff;
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: @c-blue;
    }

    .el-table,
    .el-table__expanded-cell,
    .el-table th,
    .el-table tr {
        background-color: transparent;
    }

    .el-table th {
        background-color: rgba(27, 98, 224, .16);
        color: #9ec7ff;
        font-weight: 500;
    }

    .el-table td,
    .el-table th.is-leaf {
        border-bottom: 1px solid rgba(63, 156, 255, .18);
    }

    .el-table td {
        color: @c-text;
    }

    .el-table--enable-row-hover .el-table__body tr:hover>td {
        background-color: rgba(42, 125, 232, .18);
    }

    .el-table::before,
    .el-table::after {
        background-color: rgba(63, 156, 255, .2);
    }

    .el-pagination {
        color: @c-sub;
    }

    .el-pagination.is-background .el-pager li {
        background-color: rgba(27, 98, 224, .12);
        border: 1px solid rgba(63, 156, 255, .25);
        color: @c-sub;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: rgba(42, 125, 232, .35);
        border-color: @c-blue;
        color: #eaf6ff;
    }

    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .btn-next {
        background-color: rgba(27, 98, 224, .12);
        border: 1px solid rgba(63, 156, 255, .25);
        color: @c-sub;
    }

    .el-pagination__total,
    .el-pagination__sizes .el-input__inner {
        color: @c-sub;
    }
}

/* ===== mobile ===== */
.mobile_submit {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: transparent;
    height: 60px;
    gap: 10px;
    padding: 0 10px;
    box-sizing: border-box;
}

/* 窄屏堆叠 */
@media (max-width: 1280px) {
    .ex-page {
        height: auto;
    }

    .ex-body {
        grid-template-columns: 1fr;
    }

    .ex-idbar {
        flex-wrap: wrap;
    }

    .ex-kpis {
        width: 100%;
    }

    .ex-kpi {
        flex: 1;
    }

    .ex-video-card {
        flex: none;
    }

    .ex-video-empty {
        min-height: 260px;
    }

    .ex-record-card,
    .ex-eval-card {
        flex: none;
    }

    .ex-logs,
    .ex-rules {
        max-height: 420px;
    }
}
</style>
